import gql from 'graphql-tag'

export const QUERY_GET_PRODUCTS_ANALYTICS = gql`
  query ProductAnalytics(
    $products: [String!]!
    $search: String
    $currentInitialDate: String
    $currentFinalDate: String
    $referenceInitialDate: String
    $referenceFinalDate: String
    $units: [String]
    $page: Int
    $pageSize: Int
  ) {
    productAnalytics(
      products: $products
      search: $search
      currentInitialDate: $currentInitialDate
      currentFinalDate: $currentFinalDate
      referenceInitialDate: $referenceInitialDate
      referenceFinalDate: $referenceFinalDate
      units: $units
      page: $page
      pageSize: $pageSize
    ) {
      records
      page
      productAnalytics {
        sku
        productName
        currentRevenue
        referenceRevenue
        potentialRevenue
      }
    }
  }
`
export const QUERY_GET_BOOSTING_PRODUCTS = gql`
  query salesBoostingProducts($products: [String!]!, $units: [String], $page: Int, $pageSize: Int) {
    salesBoostingProducts(products: $products, units: $units, page: $page, pageSize: $pageSize) {
      records
      page
      salesBoostingProducts {
        product {
          sku
          name
        }
        confidence
      }
    }
  }
`
export const MUTATION_SALES_PRODUCTS_ANALYSIS_REPORT = gql`
  mutation (
    $emails: [String!]!
    $fileFormat: FileFormatType
    $products: [String!]!
    $referenceFinalDate: String!
    $referenceInitialDate: String!
    $units: [String!]
    $currentInitialDate: String!
    $currentFinalDate: String!
  ) {
    createSalesProductsAnalysisReport(
      emails: $emails
      fileFormat: $fileFormat
      products: $products
      referenceFinalDate: $referenceFinalDate
      referenceInitialDate: $referenceInitialDate
      units: $units
      currentInitialDate: $currentInitialDate
      currentFinalDate: $currentFinalDate
    ) {
      id
      state
      filesUrl
      payload {
        emails
        products
        fileFormat
        currentFinalDate
        currentInitialDate
        referenceFinalDate
        referenceInitialDate
        units
      }
      fileUrl
    }
  }
`
export const MUTATION_REFRESH_OPPORTUNITIES = gql`
  mutation RefreshOpportunities($skus: [String]) {
    refreshOpportunities(skus: $skus)
  }
`
